export default {"src":"/_next/static/media/StarHalfDark.4429529b.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};